import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './components/auth/auth.guard';
import { PageNotFoundComponent } from './pages/not-found.component';
import { NotAuthorizedComponent } from './pages/not-authorized-compoment';
import { AuthRoleGuard } from './components/auth/auth-role.guard';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { SliderModule } from 'primeng/slider';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SpinnerModule } from 'primeng/spinner';
import {SplitButtonModule} from 'primeng/splitbutton';

import { TooltipModule } from 'primeng/tooltip';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { PaginatorModule } from 'primeng/paginator';

import { GroupByPipe } from '../../CustomPipes/GroupBy';
import { ListboxModule } from 'primeng/listbox';
import { RbLetterAvatarModule } from 'rb-letter-avatar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { PanelModule } from 'primeng/panel';
import { LazyLoadedTableComponent } from './components/lazy-loaded-table/lazy-loaded-table.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
//import { PopoverModule } from 'ngx-popover';
import { AngularSplitModule } from 'angular-split';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FileUploadModule } from 'primeng/fileupload';
import { SignalRService } from '../../services/signalr/signal-rservice.service';
import { GalleriaModule } from 'primeng/galleria'; import { OverlayPanelModule } from 'primeng/overlaypanel'; import { ConfirmDialogModule } from 'primeng/confirmdialog';
//import { far } from '@fortawesome/free-regular-svg-icons';

import 'hammerjs'; // Mandatory for angular-modal-gallery 3.x.x or greater (`npm i --save hammerjs`)
import 'mousetrap'; // Mandatory for angular-modal-gallery 3.x.x or greater (`npm i --save mousetrap`)
//import { ModalGalleryModule } from '@ks89/angular-modal-gallery';
import { MfFormFieldsComponent } from '@framework/components/mf-form-fields/mf-form-fields.component';
import { ListPageComponent } from '@framework/components/mf-list-page/mf-list-page.component';
import { DetailsPageComponent } from '@framework/components/mf-form/mf-form-page.component';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { MfTableComponent } from '@framework/components/mf-table/mf-table.component';
import { MfFormControlComponent } from '@framework/components/mf-form-control/mf-form-control.component';
import { CheckboxModule } from 'primeng/checkbox';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { NbDatepickerModule, NbToastrModule, NbActionsModule, NbAlertModule, NbStepperModule, NbAccordionModule, NbListModule, NbCardModule, NbSpinnerModule } from '@nebular/theme';
import { ThemeModule } from 'src/app/@theme/theme.module';
import { MfColumnSelectorComponent } from '@framework/components/mf-column-selector/mf-column-selector.component';
import { MfBladeFormsComponent } from '../../framework/components/mf-blade-forms/mf-blade-forms.component';
import { MfFiltersComponent } from '../../framework/components/mf-filters/mf-filters.component';
import { MfBladeComponent } from '../../framework/components/mf-blade/mf-blade.component';
import { MfGeneratedFormComponent } from '../../framework/components/mf-generated-form/mf-generated-form.component';
import { FileSaverModule } from 'ngx-filesaver';
import { DynamicDialogModule } from 'primeng/components/dynamicdialog/dynamicdialog';
import { ActionDialogComponent } from './components/action-dialog/action-dialog.component';
import {  ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { SplitterModule } from '@progress/kendo-angular-layout';
import { MfTableV2Component } from '../../framework/components/mf-table-v2/mf-table-v2.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { DateRangeFilterCellComponent } from '../../framework/components/mf-table-v2/filter-cells/date-range-filter-cell.component';
import { DropDownListFilterComponent } from '../../framework/components/mf-table-v2/filter-cells/dropdownlist-filter.componennt';
import { PartialEmailsSelectorComponent } from '../requisition/components/partial-emails-selector/partial-emails-selector.component';
import '../../framework/tools';
import { RfqSelectItemsComponent } from '../requisition/components/rfq-select-items/rfq-select-items.component';
import { CreateReqCopyComponent } from '../requisition/components/create-req-copy/create-req-copy.component';
import { SelectApproverComponent } from '../requisition/components/select-approver/select-approver.component';
import { BulkHierarchyComponent } from '../requisition/components/bulk-hierarchy/bulk-hierarchy.component';
import { CustomControlStockItemAutoCompleteComponent } from '../requisition/components/custom-control-stock-item-auto-complete/custom-control-stock-item-auto-complete.component';
import { ReqItemExcelImportComponent } from '../requisition/components/req-item-excel-import/req-item-excel-import.component';

import { MatExpansionModule } from '@angular/material';
import { RequisitionTutorialBlades } from '../../framework/components/mf-blade-forms/MfBladeFormsExt';
import { TutorialComponent } from '../requisition/components/tutorial/tutorial.component';
import { RequisitionTutorialBlade } from '../../framework/components/mf-blade/MfBladeExt';
import { EmailLookupComponent } from '../shared/components/email-lookup/email-lookup.component';

library.add(fas);


@NgModule({
  imports: [
    ComboBoxModule, DateInputsModule, NumericTextBoxModule,
    StorageServiceModule,
    FormsModule, // [(ngModel)]
    CommonModule, // ngFor, ngIf, ngStyle, ngClass, date, json,
    DropdownModule, SplitterModule,
    TableModule,
    ProgressSpinnerModule,
    CardModule,
    ButtonModule,
    CalendarModule,
    InputTextModule,
    RadioButtonModule,
    MultiSelectModule,
    TriStateCheckboxModule,
    SliderModule,
    AutoCompleteModule,
    InputSwitchModule,
    InputMaskModule,
    InputTextareaModule,
    SpinnerModule,
    ReactiveFormsModule,
    TooltipModule,
    TabViewModule,
    ListboxModule,
    RbLetterAvatarModule,
    FontAwesomeModule,
    PanelModule,
    ToggleButtonModule, ButtonModule,
    DialogModule,
    AccordionModule,
    //PopoverModule,
    AngularSplitModule.forRoot(),
    KeyFilterModule,
    FileUploadModule,
    GalleriaModule,
    //ModalGalleryModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbToastrModule.forRoot(),
    CheckboxModule,
    BreadcrumbModule,
    NbActionsModule,
    ThemeModule,
    NbAlertModule,
    NbAccordionModule,
    NbStepperModule,
    NbListModule,
    CardModule, 
    NbCardModule,
    PaginatorModule,
    ProgressBarModule, NbSpinnerModule, OverlayPanelModule, ConfirmDialogModule,
     SplitButtonModule,
    FileSaverModule, DynamicDialogModule, GridModule, ScrollViewModule,

    MatExpansionModule,
  ],
  providers: [
    
  ],
  declarations: [
    PageNotFoundComponent, 
    MfFiltersComponent,
    NotAuthorizedComponent,
    GroupByPipe, 
    LazyLoadedTableComponent,
    MfColumnSelectorComponent,
    MfFormFieldsComponent,
    ListPageComponent, DetailsPageComponent,
    MfTableComponent,
    MfFormControlComponent,
    MfBladeFormsComponent,
    MfBladeComponent,
    MfGeneratedFormComponent, MfFiltersComponent, ActionDialogComponent, MfTableV2Component, DropDownListFilterComponent, DateRangeFilterCellComponent, PartialEmailsSelectorComponent, RfqSelectItemsComponent, SelectApproverComponent, BulkHierarchyComponent,
    CustomControlStockItemAutoCompleteComponent,
    ReqItemExcelImportComponent, RequisitionTutorialBlades, TutorialComponent, RequisitionTutorialBlade,CreateReqCopyComponent ,EmailLookupComponent
  ],
  entryComponents: [MfColumnSelectorComponent, MfFiltersComponent, ActionDialogComponent, PartialEmailsSelectorComponent, RfqSelectItemsComponent,CreateReqCopyComponent, SelectApproverComponent, BulkHierarchyComponent, CustomControlStockItemAutoCompleteComponent,
    ReqItemExcelImportComponent, RequisitionTutorialBlades, TutorialComponent, RequisitionTutorialBlade,EmailLookupComponent ],
  exports: [ComboBoxModule, DateInputsModule, NumericTextBoxModule, SplitterModule,
    StorageServiceModule,
    FormsModule, ProgressBarModule, TableModule, DetailsPageComponent, MfFiltersComponent, 
    MfBladeComponent, MfGeneratedFormComponent,
    ProgressSpinnerModule,
    CardModule,
    ButtonModule,
    DropdownModule,
    CalendarModule,
    InputTextModule,
    RadioButtonModule,
    MultiSelectModule,
    TriStateCheckboxModule,
    CheckboxModule,
    SliderModule,
    AutoCompleteModule,
    InputSwitchModule,
    InputMaskModule,
    InputTextareaModule,
    SpinnerModule,
    TooltipModule,
    TabViewModule,
    ListboxModule,
    RbLetterAvatarModule,
    FontAwesomeModule,
    PanelModule,
    LazyLoadedTableComponent,
    ToggleButtonModule, 
    DialogModule,
    MfColumnSelectorComponent,
    AccordionModule,
    //PopoverModule,
    AngularSplitModule,
    KeyFilterModule,
    FileUploadModule,
    GalleriaModule,
    //ModalGalleryModule,
    NbDatepickerModule,
    MfFormFieldsComponent,
    ListPageComponent,
    MfTableComponent,
    MfFormControlComponent,
    BreadcrumbModule,
    NbToastrModule,
    NbActionsModule,
    ThemeModule,
    NbAlertModule,
    NbAccordionModule,
    NbStepperModule,
    NbListModule,
    CardModule,
    PaginatorModule,
    NbCardModule, NbSpinnerModule
    , OverlayPanelModule, ConfirmDialogModule,
     SplitButtonModule,
    
    FileSaverModule, DynamicDialogModule, GridModule, MfTableV2Component, ScrollViewModule, DropDownListFilterComponent, DateRangeFilterCellComponent, CustomControlStockItemAutoCompleteComponent,

    MatExpansionModule,
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      providers: [AuthGuard, AuthRoleGuard, SignalRService],
      ngModule: SharedModule
    };
  }
}
